import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import { Api } from './api.service'
import type { TypeParams } from './types'

/** TODO */
@ngCore.Injectable({ providedIn: 'root' })
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    super({
      api: ngCore.inject(Api),
      identify: ({ id }) => id,
      name: ec.Name.Predefined.QuiverPackage,
      plugins: {
        additionalFactories: [new ds.table.ec.Factory<TypeParams>()],
      },
    })
  }
}
